/**
 * 计算给定字段的总计
 * @param {Array} array 对象数组数据
 * @param {String} computedField  需要进行合计的字段名
 * @return {Number} 合计后的结果
 */
export function totalSum(array, computedField) {
    if (!array || array.length === 0) {
        return 0
    } else {
        return array.reduce((value, item) => value + +item[computedField], 0)
    }
}
